/* eslint-disable max-len */
import React, { Component } from 'react';
import { withHousehold } from 'Context/HouseholdContext';
import PropTypes from 'prop-types';
import './Notes.css';
import RoundButton from 'Components/UI/RoundButton';
import { householdBlueprintUri } from 'Consts/advisorUris';
import { Link } from 'react-router-dom';
import { SwaggerlessContext } from 'Context/SwaggerlessContext';

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footnotesCount: 0,
      recommendationsCount: 0,
      strategiesCount: 0,
    };
  }

  componentDidMount() {
    this.getNotes();
  }

  getNotes() {
    const { householdId } = this.props;
    const { getQuestionnaireSectionNotes } = this.context;
    getQuestionnaireSectionNotes(householdId).then((res) => {
      if ('data' in res && res.data) {
        const noteMap = {
          recommendation: 0,
          strategy: 0,
          footnote: 0,
        };
        res.data.forEach((note) => {
          if (note.attributes.type in noteMap) {
            noteMap[note.attributes.type]++;
          }
        });
        this.setState({
          footnotesCount: noteMap.footnote,
          recommendationsCount: noteMap.recommendation,
          strategiesCount: noteMap.strategy,
        });
      }
    });
  }

  render() {
    const {
      recommendationsCount,
      footnotesCount,
      strategiesCount,
    } = this.state;
    const { householdId } = this.props;
    return (
      <div className="landing-questionnaire-notes">
        <div className="note-count note-recommendation">
          <p className="label">Recommendations</p>
          <p className="val">{recommendationsCount}</p>
        </div>
        <div className="note-count note-strategy">
          <p className="label">Strategy</p>
          <p className="val">{strategiesCount}</p>
        </div>
        <div className="note-count note-footnote">
          <p className="label">Footnotes</p>
          <p className="val">{footnotesCount}</p>
        </div>
        <div className="blueprint-link">
          <RoundButton
            to={householdBlueprintUri(householdId)}
            component={Link}
            className="view-blueprint-button"
            color="primary"
            disableElevation
            text="View Blueprint"
            variant="contained"
          >
            {'View Blueprint'}
          </RoundButton>
        </div>
      </div>
    );
  }
}

Notes.contextType = SwaggerlessContext;

Notes.propTypes = {
  householdId: PropTypes.number.isRequired,
};

const NotesContainer = withHousehold(Notes);

export default NotesContainer;
